/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { BackendService } from '../../../../../utils/src/lib/sysque-backend/backend.service';
import { CallsService } from '../../../../../utils/src/lib/backend-calls/calls-backend-service';
import {
  BrowseClick,
  BrowseClickSuccess,
  ChangeDialogHeight,
  ChangeDialogHeightSuccess,
  ImportScheduleClick,
  ImportScheduleClickSuccess,
} from './import-schedule-actions';
import { GlobalConstants } from '../../constants/global-constants';

@Injectable()
export class ImportScheduleEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly backendService: BackendService,
    private readonly service: CallsService
  ) {}

  changeDialogHeight$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChangeDialogHeight),
      concatMap(({ height }) => {
        this.service.onWindowResize(GlobalConstants.ChangeHeight, height);
        return of(ChangeDialogHeightSuccess({ response: 'OK' }));
      })
    )
  );

  browseClick$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BrowseClick),
      concatMap(() =>
        this.backendService.browseClick().pipe(
          map(response => BrowseClickSuccess({ response }))
        )
      )
    )
  );

  importScheduleClick$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ImportScheduleClick),
      concatMap(({ scheduleName }) => {
        this.backendService.importScheduleClick(scheduleName);
        return of(ImportScheduleClickSuccess({ response: 'OK' }));
      })
    )
  );
}
